import React from 'react';
import { getUserInformation } from '../components/Login/loginService';
import { getDefaultHeader } from '../services/serviceAPIHelper';


let childHandler;
export function cmsParentHandler(handler) {
    childHandler = handler;
}
export function cmsChildHandler(childName, data) {
    if (childHandler) {
        childHandler(childName, data);
    }
}
let cmsConfigStoreName = 'cmsConfiguration';
/**
 * CMS configuration utilities functions.
 */
let cmsConfiguration = null;
export function clsCMSConfiguration() {
    cmsConfiguration = null;
}
export function setCMSConfiguration(cmsconf, language) {
    cmsconf = {
        ...cmsconf,
        language: language
    };
    localStorage.setItem(cmsConfigStoreName, JSON.stringify(cmsconf));
    cmsConfiguration = cmsconf;
    setColorTheming(cmsconf);
}

export function setColorTheming(cmsconf) {
    try {
        if (cmsconf && cmsconf.color) {
            Object.keys(cmsconf.color).forEach(key => {
                document.documentElement.style.setProperty('--' + key, cmsconf.color[key]);
                //will automtically add alpha colors
                document.documentElement.style.setProperty('--' + key + '-alpha', cmsconf.color[key] + '50');
            });
        }
    } catch (error) {
        console.error(error);
    }
}

export function getCMSConfiguration() {
    cmsConfiguration = localStorage.getItem(cmsConfigStoreName);
    if (!cmsConfiguration || cmsConfiguration === '') {
        return { layout: { widgets: [] } };
    }
    
     cmsConfiguration = JSON.parse(cmsConfiguration);
    
    
    return cmsConfiguration;
}

export function getCMSWidget(pos) {
    let conf = getCMSConfiguration();
    let widgets = conf.layout.widgets.filter(w => w.orden === pos);
    if (widgets.length > 0) {
        let tw = widgets[0];
        return tw;
    }
    return {
        order: pos,
        type: 'MissingWidget',
        description: 'MissingWidget at ' + pos,
        action: ''
    };
}
let WidgetDebug = function statelessFunctionComponentClass(props) {
    const {widget} = props;

    return  (
        <div><h3>{widget && widget.type.toString()}</h3><code style={{ whiteSpace: 'pre' }}>{JSON.stringify(widget, null, 2)}</code></div>
    );
};

export function getCMSWidgetComponent(pos, extraParams, cssClass) {
    let widget = getCMSWidget(pos);
    let WClass = null;
    try {
        WClass = require('./widgets/' + widget.type).default;
    } catch (error) {
        WClass = WidgetDebug;
    }
    return <WClass widget={widget} parameters={extraParams} className={cssClass} />;
}
export function getCMSWidgetComponentByObject(widget, extraParams) {
    let WClass = null;
    try {
        WClass = require('./widgets/' + widget.type).default;
    } catch (error) {
        WClass = WidgetDebug;
    }
    return <WClass widget={widget} parameters={extraParams} />;
}

export function getCMSWidgetClassByObject(widget) {
    let WClass = null;
    try {
        WClass = require('./widgets/' + widget.type).default;
    } catch (error) {
        WClass = WidgetDebug;
    }
    return WClass;
}

export async function getCMSSectionContent(section, parent, order) {
    let rooturl = process.env.REACT_APP_API_URL;
    let user = getUserInformation();
    //section?apiclient=b2bwebolympia&agencyCode=CLIENTES%20OLYMPIA%20INT&language=es&section=openlandingaction&position=0
    let url = `${rooturl}masterdata/section?apiclient=${user.accountName}&agencyCode=${user.user_detail.agency_code}&language=${user.user_detail.language}&section=${section}&parentOrder=${parent}&order=${order}`;

    const response = await fetch(url, {
        method: 'GET',
        headers: getDefaultHeader(true)
    });

    if (response.status === 200) {
        return await response.json();
    } else {
        console.error('Error retrievingn getCMSSectionContent');
        const error = await response.json();
        throw error;
    }
}

export async function getPreviewConfiguration(accountName, lang, settingId) {
    let rooturl = process.env.REACT_APP_API_URL;
    //section?apiclient=b2bwebolympia&agencyCode=CLIENTES%20OLYMPIA%20INT&language=es&section=openlandingaction&position=0
    let url = `${rooturl}masterdata/configurationpreview?apiclient=${accountName}&language=${lang}&settingId=${settingId}`;
    const response = await fetch(url, {
        method: 'GET',
        headers: getDefaultHeader(false)
    });
    if (response.status === 200) {
        return await response.json();
    } else {
        console.error('Error retrievingn getCMSSectionContent');
        const error = await response.json();
        throw error;
    }
}

let HeaderNull = function statelessFunctionComponentClass(props) {
    // let { parameters, name }  = props;
    return (<div></div>);
};

export function getCMSHeader(name, extraParams) {
    let Clazz = null;
    try {
        if (extraParams && extraParams.type && extraParams.type === 'OpenLandingAction') {
            Clazz = require('./headers/' + 'LandingHeader').default;
        } else {
            Clazz = require('./headers/' + name).default;
        }
    } catch (error) {
        Clazz = HeaderNull;
    }
    return <Clazz name={name} parameters={extraParams} />;
}

export function getLabels(labels, type) {
    if (labels) {
        let fie = labels.filter(l => { return l.key.indexOf(type) !== -1; });        
        if (fie && fie.length > 0) {
            return fie[0].value.replace(/(\r\n|\n|\r)/gm, '');
        }
    }
    return null;
}

export async function getNewsAsync(limit) {
    let rooturl = process.env.REACT_APP_API_URL;
    let lang = '';
    if (window.location.href.indexOf('#/preview') !== -1) {
        const cmsConfig = getCMSConfiguration();
        lang = cmsConfig.language;
    } else {
        const user = getUserInformation();
        lang = user.user_detail.language;        
    }
    let url = `${rooturl}masterdata/news?lang=${lang}&limit=${limit}`;
    const response = await fetch(url, {
        method: 'GET',
        headers: getDefaultHeader(true)
    });
    if (response.status === 200) {
        return await response.json();
    } else {
        const error = await response.json();
        throw error;
    }
}


// WEBPACK FOOTER //
// ./src/cms/cmsLib.js